import { render, staticRenderFns } from "./template_upgrade_button.vue?vue&type=template&id=549e1b86&scoped=true&"
import script from "./template_upgrade_button.vue?vue&type=script&lang=js&"
export * from "./template_upgrade_button.vue?vue&type=script&lang=js&"
import style0 from "./template_upgrade_button.vue?vue&type=style&index=0&id=549e1b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e1b86",
  null
  
)

export default component.exports